interface UDToggleProps {
    on: boolean;
    onChange: (on: boolean) => void;
    title: string;
    desc: string;
    disabled?: boolean;
}

export function UDToggle({ on, onChange, title, desc, disabled }: UDToggleProps) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={on}
            disabled={disabled}
            onClick={() => onChange(!on)}
            className={`flex items-start gap-3 text-left w-full ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
            <span
                className={`w-9 h-5 rounded-full p-0.5 flex items-center shrink-0 mt-0.5 transition-colors ${
                    on ? 'bg-gray-900' : 'bg-gray-200'
                }`}
            >
                <span
                    className={`w-4 h-4 rounded-full bg-white transition-transform ${on ? 'translate-x-4' : ''}`}
                />
            </span>
            <span className="min-w-0">
                <span className="block text-[13px] font-semibold text-gray-800">{title}</span>
                <span className="block text-[12px] text-gray-500 leading-snug mt-0.5">{desc}</span>
            </span>
        </button>
    );
}
